import { Knopf } from "./knopf";

/**
 * Monatszeile („Mein Monat“, Musterkatalog M-079, Kantine-Startseite v2): EINE schmale Karte mit Titel und Zeitraum links,
 * drei Kennzahlen in der Mitte (Beschriftung, Zahl, Untertext) und Textlinks rechts; unter `lg` stapelt sie: Titel, die
 * Kennzahlen nebeneinander, die Links darunter. Ersetzt drei einzelne `KpiKarte` (Abweichung AW-095 (3), löst AW-091 (2) ab).
 *
 * Rein darstellend, nur eigene Zahlen der Person (kein Vergleich, kein Ranking, r177): was in `kennzahlen` steht, entscheidet
 * der Aufrufer. Markup aus Kennzahlkachel B (Beschriftung `text-xs uppercase`, Zahl `font-semibold`) und Kartenform der
 * `ListenKarte`; Links als `Knopf` Variante „text“ mit Chevron.
 */
export interface MonatsKennzahl {
  /** Beschriftung („Essen“, „Strichliste“, „Noch nicht abgerechnet“). */
  label: string;
  /** Die Zahl als fertiger Text („6 Mahlzeiten“, „45,10 €“). */
  wert: string;
  /** Zusatz unter der Zahl („41,40 €“, „Essen und Striche“). */
  untertext?: string;
}

export function MonatsZeile({
  id,
  titel,
  zeitraum,
  kennzahlen,
  links,
}: {
  id: string;
  titel: string;
  zeitraum: string;
  kennzahlen: MonatsKennzahl[];
  links: { href: string; text: string }[];
}) {
  const titelId = `${id}-titel`;
  return (
    <>
      {/* Preline: dashboards/admin-dashboard/index.html#browsers-card */}
      <section id={id} aria-labelledby={titelId} className="bg-card border border-card-line shadow-2xs rounded-xl">
        <div className="flex flex-col lg:flex-row lg:items-stretch">
          <div className="p-4 lg:px-5 lg:w-44 lg:shrink-0 lg:flex lg:flex-col lg:justify-center">
            <h2 id={titelId} className="text-sm font-semibold text-foreground">
              {titel}
            </h2>
            <p className="text-sm text-muted-foreground-1">{zeitraum}</p>
          </div>
          <dl className="grid grow grid-cols-3 border-t lg:border-t-0 lg:border-s border-line-2 divide-x divide-line-2">
            {kennzahlen.map((k) => (
              <div key={k.label} className="p-4 min-w-0">
                <dt className="text-xs uppercase text-muted-foreground-1">{k.label}</dt>
                <dd className="mt-1 text-base font-semibold text-foreground lg:text-lg">{k.wert}</dd>
                {k.untertext && <dd className="text-xs text-muted-foreground-1">{k.untertext}</dd>}
              </div>
            ))}
          </dl>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1 p-4 border-t lg:border-t-0 lg:border-s border-line-2 lg:px-5">
            {links.map((l) => (
              <Knopf
                key={l.href}
                href={l.href}
                variante="text"
                symbol={
                  <svg className="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                }
              >
                {l.text}
              </Knopf>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
